var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fam-stack"},[_c('avatar-stack',{attrs:{"avatars":_vm.avatars}}),_c('div',{staticClass:"copy"},[_vm._v(_vm._s(_vm.avatars.length)+"位参观者")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }